import './Label.css'
import React from 'react'

export default props => {
    return (
        <div className="labelUnbreakable">
            <p>{props.label}</p>                    
        </div>
    )
}